<template>
  <component
    :is="tag"
    :to="to"
    :class="{ 'tw:hover:no-underline': isUnderlineHover }"
    class="tw:py-2.5 tw:sm:py-3 tw:flex tw:items-center tw:cursor-pointer"
    @click="onClick"
    :data-testid="dataTestId"
  >
    <span
      class="tw:truncate tw:duration-300 tw:transition-opacity tw:flex tw:items-center tw:justify-between tw:w-full tw:md:w-auto"
      ><slot
    /></span>
  </component>
</template>

<script setup>
defineProps({
  to: {
    type: String,
    default: '#',
  },
  tag: {
    type: String,
    default: 'a',
  },
  isIcon: {
    type: Boolean,
    default: true,
  },
  isUnderlineHover: Boolean,
  dataTestId: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['onClick'])

const onClick = e => {
  emit('onClick', e)
}
</script>
